import { render } from "./AdminCoursePreview.vue?vue&type=template&id=c598c7cc&scoped=true"
import script from "./AdminCoursePreview.vue?vue&type=script&lang=js"
export * from "./AdminCoursePreview.vue?vue&type=script&lang=js"

import "./AdminCoursePreview.vue?vue&type=style&index=0&id=c598c7cc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c598c7cc"]])

export default __exports__